document.addEventListener('alpha.loaded', (e) => {
  const alphaModuleMgr = e.detail.emitter
  const alphaConfig = alphaModuleMgr.getConfig()
  const navMainInnerEl = document.querySelector('.nav-main-inner')
  const navMainParentEl = document.querySelector('.offcanvas-body-inner-wrapper,.navbar-collapse')
  if (navMainInnerEl && navMainParentEl) {
    // handle switch of "secondary" nav types to mobile menu if necessary
    const navTypes = ['currency', 'language', 'secondary']
    navTypes.forEach((navType) => {
      const navEl = document.querySelector(`.nav-${navType}`)
      const navInnerEl = document.querySelector(`.nav-${navType}-inner`)
      if (navEl && navInnerEl) {
        // listen to viewport changes and move this nav to top bar / collapsed mobile menu if necessary
        const desktopBreakpoint = alphaConfig.desktopBreakpoint
        alphaModuleMgr.addModuleEventListener('viewport', 'changed', (evt) => {
          if (evt.viewport.is(`>=${desktopBreakpoint}`)) {
            const initialLocation = navEl.contains(navInnerEl)
            if (!initialLocation) {
              navEl.appendChild(navInnerEl)
            }
          } else {
            const inMenu = navMainParentEl.contains(navInnerEl)
            if (!inMenu) {
              navMainParentEl.appendChild(navInnerEl)
            }
          }
        })
      }
    })
  }
})
